/**
 * Resolve display label for assigned_worker_id using API field and/or workers directory map.
 * @param {object} job
 * @param {Record<string, string>} workerNameById - keys: worker id and username (lowercase)
 * @returns {{ name: string|null, id: string|null }}
 */
export function resolveAssignedWorker(job, workerNameById = {}) {
  const rawId = job?.assigned_worker_id;
  if (rawId == null || String(rawId).trim() === '') {
    return { name: null, id: null };
  }
  const id = String(rawId).trim();
  const fromApi = job.assigned_worker_name && String(job.assigned_worker_name).trim();
  const fromMap =
    workerNameById[id] ||
    workerNameById[id.toLowerCase()] ||
    null;
  const name = fromApi || fromMap || null;
  return { name, id };
}

export function enrichJobsWithWorkerNames(jobs, workerNameById) {
  if (!Array.isArray(jobs)) return [];
  return jobs.map((j) => {
    const { name } = resolveAssignedWorker(j, workerNameById);
    return name ? { ...j, assigned_worker_name: name } : j;
  });
}
